import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import "../styles/AdminHolidayList.css";

const API = "/api/holidaylist";

const AdminHolidayList = () => {
  const [holidays, setHolidays] = useState([]);
  const [vacations, setVacations] = useState([]);

  // ✅ HEADER STATE ADDED
  const [header, setHeader] = useState("");

  const [form, setForm] = useState({
    title: "",
    start_date: "",
    end_date: "",
    months: "",
    day: "",
    hdate: "",
    holiday_year: 2026,
    lstyear: 2026,
  });

  const [editId, setEditId] = useState(null);

  const [vacForm, setVacForm] = useState({
    type: "",
    description: "",
    holiday_year: 2026,
  });

  const [vacEditId, setVacEditId] = useState(null);

  // ================= FETCH =================
  const fetchData = async () => {
    const res = await axios.get(API);

    setHolidays(res.data.holidays || []);
    setVacations(res.data.vacations || []);
    setHeader(res.data.header || ""); // ✅ FIXED
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ================= HEADER UPDATE =================
  const updateHeader = async () => {
    try {
      // update ALL vacation rows with same header
      for (let v of vacations) {
        await axios.put(`${API}/vacation/${v.id}`, {
          ...v,
          header: header,
        });
      }

      fetchData();
      alert("Header Updated Successfully");
    } catch (err) {
      console.log(err);
    }
  };

  // ================= DATE FORMAT =================
  const formatToDDMMYYYY = (value) => {
    if (!value) return "";
    const [y, m, d] = value.split("-");
    return `${d}-${m}-${y}`;
  };

  // ================= SUPERSCRIPT =================
  const formatSuperscript = (text) => {
    if (!text) return "";
    return text.replace(
      /(\d+)(st|nd|rd|th)/g,
      (_, num, suf) => `${num}<sup>${suf}</sup>`
    );
  };

  // ================= HOLIDAY =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "start_date" || name === "end_date") {
      setForm({ ...form, [name]: formatToDDMMYYYY(value) });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async () => {
    if (editId) {
      await axios.put(`${API}/holiday/${editId}`, form);
    } else {
      await axios.post(`${API}/holiday`, form);
    }
    resetForm();
    fetchData();
    
  };

  const handleEdit = (item) => {
    setForm(item);
    setEditId(item.event_id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API}/holiday/${id}`);
    fetchData();
  };

  const resetForm = () => {
    setForm({
      title: "",
      start_date: "",
      end_date: "",
      months: "",
      day: "",
      hdate: "",
      holiday_year: 2026,
      lstyear: 2026,
    });
    setEditId(null);
  };

  // ================= VACATION =================
  const handleVacChange = (e) => {
    setVacForm({ ...vacForm, [e.target.name]: e.target.value });
  };

  const handleVacSubmit = async () => {
    if (vacEditId) {
      await axios.put(`${API}/vacation/${vacEditId}`, vacForm);
    } else {
      await axios.post(`${API}/vacation`, vacForm);
    }
    resetVacForm();
    fetchData();
  };

  const handleVacEdit = (v) => {
    setVacForm(v);
    setVacEditId(v.id);
  };

  const handleVacDelete = async (id) => {
    await axios.delete(`${API}/vacation/${id}`);
    fetchData();
  };

  const resetVacForm = () => {
    setVacForm({
      type: "",
      description: "",
      holiday_year: 2026,
    });
    setVacEditId(null);
  };

  return (
    <div className="admin-holiday">
      <h2>Holiday & Vacation Management</h2>

      {/* ✅ HEADER EDIT (ADDED WITHOUT TOUCHING DESIGN) */}
      <div className="form-box">
        <input
          value={header}
          onChange={(e) => setHeader(e.target.value)}
          placeholder="List of Holidays Academic Year (2026-2027)"
        />

        <div className="btn-group">
          <button onClick={updateHeader}>Update Header</button>
        </div>
      </div>

      {/* ===== HOLIDAY FORM ===== */}
      <div className="form-box">
        <input name="title" placeholder="Holiday Title" value={form.title} onChange={handleChange} />

        <input type="date" name="start_date" onChange={handleChange} />
        <input type="date" name="end_date" onChange={handleChange} />

        <input name="months" placeholder="Month" value={form.months} onChange={handleChange} />
        <input name="day" placeholder="Day" value={form.day} onChange={handleChange} />

        <input
          name="hdate"
          placeholder="25th March, 2026"
          value={form.hdate}
          onChange={handleChange}
        />

        <div
          className="preview"
          dangerouslySetInnerHTML={{
            __html: formatSuperscript(form.hdate),
          }}
        />

        <div className="btn-group">
          <button onClick={handleSubmit}>
            {editId ? "Update Holiday" : "Add Holiday"}
          </button>
          <button className="reset" onClick={resetForm}>Reset</button>
        </div>
      </div>

      {/* ===== HOLIDAY TABLE ===== */}
      <table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Date</th>
            <th>Month</th>
            <th>Day</th>
            <th>Full Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {holidays.map((item) => (
            <tr key={item.event_id}>
              <td>{item.title}</td>
              <td>{item.start_date}</td>
              <td>{item.months}</td>
              <td>{item.day}</td>
              <td>{item.hdate}</td>
              <td>
                <button onClick={() => handleEdit(item)}>Edit</button>
                <button onClick={() => handleDelete(item.event_id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ===== VACATION ===== */}
      <div className="vacation-admin">
        <h3>Vacation Management</h3>

        <select name="type" value={vacForm.type} onChange={handleVacChange}>
          <option value="">Select</option>
          <option value="Summer">Summer</option>
          <option value="Winter">Winter</option>
        </select>

        <textarea
          name="description"
          placeholder="Vacation description..."
          value={vacForm.description}
          onChange={handleVacChange}
        />

        <div className="btn-group">
          <button onClick={handleVacSubmit}>
            {vacEditId ? "Update" : "Add"}
          </button>
          <button className="reset" onClick={resetVacForm}>Reset</button>
        </div>

        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {vacations.map((v) => (
              <tr key={v.id}>
                <td>{v.type}</td>
                <td>{v.description}</td>
                <td>
                  <button onClick={() => handleVacEdit(v)}>Edit</button>
                  <button onClick={() => handleVacDelete(v.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminHolidayList;